// extracted by mini-css-extract-plugin
export default {"chart":"StatProspect_chart__X4H-K","legend":"StatProspect_legend__EC3Y0","title":"StatProspect_title__l-ZTs","percent":"StatProspect_percent__B2gmj"};